import { AlertTriangle, Database, LoaderCircle } from "lucide-react";
export function LoadingState({ label = "Cultivando os dados…" }: { label?: string }) {
  return (
    <div className="state-view">
      <LoaderCircle className="spin" size={26} />
      <strong>{label}</strong>
    </div>
  );
}
export function ErrorState({
  message = "Não foi possível carregar os dados.",
}: {
  message?: string;
}) {
  return (
    <div className="state-view state-view--error">
      <AlertTriangle size={26} />
      <strong>{message}</strong>
      <span>Revise configuração, autenticação e RLS antes de tentar novamente.</span>
    </div>
  );
}
export function EmptyState({
  title = "Ainda não há dados",
  description = "Quando a telemetria chegar, esta área será preenchida sem inventar números.",
}: {
  title?: string;
  description?: string;
}) {
  return (
    <div className="state-view">
      <Database size={26} />
      <strong>{title}</strong>
      <span>{description}</span>
    </div>
  );
}
